import { render, staticRenderFns } from "./SamSectionHeader.vue?vue&type=template&id=045e43d8&scoped=true&"
import script from "./SamSectionHeader.vue?vue&type=script&lang=js&"
export * from "./SamSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SamSectionHeader.vue?vue&type=style&index=0&id=045e43d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e43d8",
  null
  
)

export default component.exports